import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../components/SafeIcon';
import { FiMapPin, FiCoffee, FiCamera, FiNavigation } from 'react-icons/fi';
import { timelineData } from '../data/mockData';

const getTypeIcon = (type) => {
  switch(type) {
    case 'food': return FiCoffee;
    case 'activity': return FiCamera;
    case 'transit': return FiNavigation;
    default: return FiMapPin;
  }
};

const getTypeColor = (type) => {
  switch(type) {
    case 'food': return 'text-coral-400 bg-coral-400/10 border-coral-400/30';
    case 'activity': return 'text-cyan-400 bg-cyan-400/10 border-cyan-400/30';
    default: return 'text-gray-300 bg-white/5 border-white/10';
  }
};

export default function TimelineView() {
  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -20 }}
      className="max-w-3xl mx-auto"
    >
      <div className="mb-8">
        <h2 className="text-2xl font-mono text-white mb-2">ITINERARY LANES</h2>
        <p className="text-gray-400 text-sm">Chronological sequence of events.</p>
      </div>

      <div className="space-y-12">
        {timelineData.map((day, dayIdx) => (
          <div key={dayIdx} className="relative">
            {/* Day Header */}
            <div className="sticky top-20 z-10 bg-midnight-900/90 backdrop-blur-md py-4 mb-6 border-b border-white/10 flex items-center justify-between">
              <h3 className="text-xl font-bold text-white">{day.day}</h3>
              <span className="font-mono text-cyan-400 text-sm">{day.date}</span>
            </div>

            {/* Timeline Events */}
            <div className="relative pl-4 md:pl-0">
              {/* Vertical Line */}
              <div className="absolute left-[27px] md:left-[120px] top-0 bottom-0 w-px bg-gradient-to-b from-cyan-400/50 via-white/10 to-transparent"></div>

              <div className="space-y-8">
                {day.events.map((event, eventIdx) => (
                  <motion.div 
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: eventIdx * 0.1 }}
                    key={eventIdx} 
                    className="relative flex flex-col md:flex-row items-start md:items-center gap-4 md:gap-8 group"
                  >
                    {/* Time (Desktop left, Mobile top) */}
                    <div className="md:w-[100px] font-mono text-sm text-gray-400 md:text-right pt-1 md:pt-0 pl-12 md:pl-0">
                      {event.time}
                    </div>

                    {/* Node */}
                    <div className={`absolute left-0 md:relative md:left-auto w-14 h-14 rounded-full border-2 flex items-center justify-center z-10 transition-transform group-hover:scale-110 bg-midnight-900 ${getTypeColor(event.type)}`}>
                      <SafeIcon icon={getTypeIcon(event.type)} className="text-xl" />
                    </div>

                    {/* Card */}
                    <div className="flex-1 glass-card p-4 ml-12 md:ml-0 hover:bg-white/10 transition-colors cursor-pointer w-full">
                      <h4 className="text-lg font-medium text-white mb-1">{event.title}</h4>
                      <div className="flex items-center gap-2 text-xs text-gray-400 font-mono">
                        <SafeIcon icon={FiMapPin} />
                        <span>{event.location}</span>
                      </div>
                    </div>
                  </motion.div>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </motion.div>
  );
}